/* tslint:disable */
/* eslint-disable */
/**
 * Planner 365 API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export enum RequestAction {
  REMOVE = 1,
  DECLINE = 2,
  APPROVE = 3,
  APPROVE_WITH_CHANGES = 4,
  REJECT = 5,
  ACCEPT = 6,
  RESET = 7,
  SAVE = 8,
}
